import { useQuery } from "@tanstack/react-query";
import * as req from "@script/req.ts";
import { useScheduleStore } from "@store/scheduleStore.ts";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";

export interface Version {
  created_at: string; // Date 대신 string (ISO 8601)
  created_by: string; // Date 대신 string
  name: string;
  schedule_id: string;
  status: "issued" | "draft";
  updated_at: string; // Date 대신 string (ISO 8601)
  version: number;
}

export default function useRosterVersions({
  groupId,
  enabled,
}: {
  groupId: string | null;
  enabled?: boolean;
}) {
  const { curDate } = useScheduleStore();

  return useQuery<Version[]>({
    queryKey: QUERY_KEYS.roster.versions(
      curDate?.year,
      curDate?.month,
      groupId
    ),
    queryFn: async () => {
      return await req.roster_versions(
        curDate!.year!,
        curDate!.month!,
        groupId
      );
    },
    enabled: enabled !== false && !!curDate?.year && !!curDate?.month,
    // placeholderData: keepPreviousData,
  });
}
